<template>
  <div>
    <div class="text-center text-2xl font-bold mb-6">🏆 Objectif du mois</div>
    <Alert>
      Ce chiffre correspond au nombre de contrats que votre magasin peut atteindre chaque mois. Il permet de
      personnaliser votre brief quotidien, d’adapter les analyses de performance, et de mieux accompagner vos vendeurs
      avec des objectifs motivants.
    </Alert>
    <div class="my-10">
      <FormField id="monthlySalesTarget" v-model="monthlySalesTarget" />
    </div>
    <div class="flex justify-center">
      <button
        type="button"
        class="inline-flex items-center rounded-2xl border border-transparent text-button-font-primary bg-primary uppercase px-6 py-3 text-base font-medium text-white shadow-xs focus:outline-hidden focus:ring-2 focus:ring-primary focus:ring-offset-2"
        @click="update"
      >
        Mettre à jour
      </button>
    </div>
  </div>
</template>

<script>
import { Alert, FormField } from "@estaly/ui";
import StoresService from "@/api/services/stores";
import { mapActions } from "vuex";

export default {
  components: {
    Alert,
    FormField,
  },
  props: ["store"],
  emits: ["updated"],
  data() {
    return {
      monthlySalesTarget: this.store.monthlySalesTarget || 0,
    };
  },
  methods: {
    ...mapActions("notifications", ["notify"]),
    async update() {
      const response = await StoresService.update(this.store.id, {
        monthlySalesTarget: this.monthlySalesTarget,
      });
      if (!response?.success) return;

      await this.notify({
        category: "simple",
        type: "success",
        title: "Mise à jour effectuée",
      });
      this.$emit("updated");
    },
  },
};
</script>
